<template>
  <span class="tag" :class="statusClass">
    {{ formatStatusLabel(status) }}
  </span>
</template>

<script>
export default {
  name: "StatusTag",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    statusClass() {
      const STATUS_STYLES = {
        APROVADO: "is-success",
        ATIVO: "is-success",
        CADASTRADO: "is-info",
        RECUSADO: "is-danger",
        PENDENTE: "is-warning",
        PENDENTE_BIOMETRIA: "is-warning",
        PENDENTE_REMOCAO: "is-warning",
        DOCUMENTACAO_EXPIRADA: "is-warning",
        EMPRESA_INATIVA: "is-warning",
        BLOQUEADO: "is-danger",
        INATIVO: "is-danger",
        DOCUMENTACAO_PENDENTE: "is-warning"
      };
      return STATUS_STYLES[this.status] || "is-light"; // Classe padrão caso o status não seja encontrado
    },
  },
  methods: {
    formatStatusLabel(value) {
      const statusLabels = {
        APROVADO: "Aprovado",
        ATIVO: "Ativo",
        CADASTRADO: "Cadastrado",
        RECUSADO: "Recusado",
        PENDENTE: "Pendente",
        PENDENTE_BIOMETRIA: "Pendente de Biometria",
        PENDENTE_REMOCAO: "Pendente Remoção",
        DOCUMENTACAO_EXPIRADA: "Documentação Expirada",
        EMPRESA_INATIVA: "Empresa Inativa",
        BLOQUEADO: "Bloqueado",
        INATIVO: "Inativo",
        DOCUMENTACAO_PENDENTE: "Documentação Pendente"
      };

      return statusLabels[value] || "N/A";
    },
  },
};
</script>

<style scoped>
.tag {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
}
</style>
